import { SegmentedControl, Stack, Text, Title } from '@mantine/core';
import { useLocation, useNavigate } from 'react-router';

type AuthContainerProps = {
    children: React.ReactNode;
    title?: string;
    subtitle?: string;
};

export const AuthContainer = ({
    children,
    title = 'Reparo',
    subtitle,
}: AuthContainerProps) => {
    const nav = useNavigate();
    const loc = useLocation();

    // Determine current tab based on path
    const currentTab = loc.pathname.includes('signup') ? 'signup' : 'login';

    return (
        <Stack
            align="center"
            justify="center"
            className="min-h-screen w-full bg-white"
            gap="xl"
        >
            <Stack align="center" gap="xs">
                <Title order={1} size={32} fw={800}>
                    {title}
                </Title>
                {subtitle && (
                    <Text c="dimmed" size="sm">
                        {subtitle}
                    </Text>
                )}
            </Stack>

            <div className="w-[400px] rounded-2xl border border-gray-200 bg-white p-6 shadow-sm">
                <Stack gap="md">
                    <SegmentedControl
                        fullWidth
                        radius="md"
                        value={currentTab}
                        onChange={(val) =>
                            nav(val === 'signup' ? '/signup' : '/login')
                        }
                        data={[
                            { label: 'Login', value: 'login' },
                            { label: 'Sign Up', value: 'signup' },
                        ]}
                        classNames={{
                            input: 'hidden',
                            label: 'font-medium',
                            indicator: 'bg-black',
                        }}
                        styles={{
                            root: { backgroundColor: '#f3f4f6' }, // gray-100
                            indicator: { backgroundColor: 'black' },
                        }}
                        // Custom styles to make selected text white and unselected black
                        // Note: Mantine SegmentedControl styles can be tricky, might need CSS classes or specific prop tuning
                        // For now using basic setup, let's refine if needed.
                        color="dark"
                    />

                    {children}
                </Stack>
            </div>
        </Stack>
    );
};
